import { ApplicationService } from '~/services/core/application.service'
import { WheelOfFortuneBonus } from '~/types/wheel-of-fortune.types'

export interface TrustedByCounterResponse {
  // eslint-disable-next-line camelcase
  trusted_by: number,
}

/* eslint-disable camelcase */
export interface WheelOfFortuneBonusDTO {
  'profit_title': string | null,
  'promocode': string,
  'profit_value': number,
  'bonus_type': 'voucher' | 'cashback',
}

export interface WheelOfFortuneResponse {
  bonuses: WheelOfFortuneBonusDTO[],
}

export class CommonService extends ApplicationService {
  get baseUrl () {
    return this.runtimeConfig.BASE_API_URL
  }

  submitContactUsForm (payload: any, token: string) {
    const formData = new FormData()
    Object.keys(payload).forEach((key: string) => {
      formData.append(key, payload[key])
    })
    formData.append('token', token)
    return this.post('/api/contact_us_message/', formData)
  }

  getDynamicPageContent (slug: string) {
    return this.get(`/api/page/${slug}/`)
  }
}
